import React from "react";
import { experience } from "../mock/mock";
import { MapPin } from "lucide-react";

const Experience = () => {
  return (
    <section id="experience" className="py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 mb-16">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-bronze" />
              <span className="text-[11px] uppercase tracking-[0.3em] text-ink/60">
                Experience
              </span>
            </div>
            <h2 className="font-serif-display text-4xl lg:text-5xl text-ink leading-[1.05] font-light">
              Two decades of building service organisations that grow.
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 flex items-end">
            <p className="text-ink/65 leading-relaxed">
              From IT systems administration in Jordan to regional service leadership across the
              GCC — each role added a new layer to the same craft: turning disciplined delivery into
              commercial outcomes.
            </p>
          </div>
        </div>

        <div className="relative">
          <div className="absolute left-3 lg:left-4 top-2 bottom-2 w-px timeline-line hidden sm:block" />

          <div className="space-y-12">
            {experience.map((exp, idx) => (
              <article key={exp.id} className="relative pl-0 sm:pl-14 lg:pl-20">
                <div className="hidden sm:block absolute left-0 top-2">
                  <div className="h-7 w-7 rounded-full border border-bronze bg-ivory-50 grid place-items-center">
                    <div className="h-2.5 w-2.5 rounded-full bg-bronze" />
                  </div>
                </div>

                <div className="grid lg:grid-cols-12 gap-6 lg:gap-10 border-b border-ink/10 pb-12">
                  <div className="lg:col-span-4">
                    <div className="text-xs uppercase tracking-[0.22em] text-bronze font-medium mb-3">
                      {exp.period}
                    </div>
                    <div className="font-serif-display text-2xl text-ink leading-tight mb-2">
                      {exp.title}
                    </div>
                    <div className="text-sm text-ink/70 mb-3">{exp.company}</div>
                    <div className="inline-flex items-center gap-1.5 text-xs text-ink/55">
                      <MapPin className="h-3.5 w-3.5" />
                      {exp.location}
                    </div>
                  </div>

                  <div className="lg:col-span-8">
                    <div className="text-[11px] uppercase tracking-[0.22em] text-ink/50 mb-4">
                      Focus · {exp.focus}
                    </div>
                    <ul className="space-y-3">
                      {exp.points.map((p, i) => (
                        <li key={i} className="flex gap-3 text-ink/75 leading-relaxed">
                          <span className="mt-2 h-1 w-1 rounded-full bg-bronze flex-shrink-0" />
                          <span className="text-[15px]">{p}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;
